import { defineElement, StyledElement } from '@webtides/element-js';
import style from './download-list.css';

/**
 * @property {string} layoutVariant
 * @property {array} pages
 */
export default class DownloadList extends StyledElement {
    /** @type {NodeListOf<ListSection>} */
    listSections;

    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            selectedCategories: [],
        };
    }

    connected() {
        this.listSections = this.querySelectorAll('mb-list-section');
    }

    events() {
        return {
            'mb-filter-tags': {
                'mb-filter-change': (event) => {
                    const selectedCategories = event.detail;
                    for (const listSection of this.listSections) {
                        listSection.style.display =
                            selectedCategories.length === 0 || selectedCategories.includes(listSection.name)
                                ? 'block'
                                : 'none';
                    }
                },
            },
        };
    }
}

defineElement('mb-download-list', DownloadList);
